import { Backdrop, CircularProgress, Typography, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		background: "rgba(255,255,255,0.7)",
		flexDirection: "column",
	},
	message: {
		marginTop: 16,
		padding: "0 24px",
		fontSize: 15,
		color: "#333333",
		textAlign: "center",
	},
}));

/**
 * @param {boolean} loading
 * @param {string}  [slowMessage]   - Mensagem exibida abaixo do spinner se o loading durar mais que `slowAfterMs`.
 * @param {number}  [slowAfterMs=3000]
 */
const SpinnerLoading = (props) => {
	const { loading, slowMessage, slowAfterMs = 3000 } = props;
	const classes = useStyles();
	const [isSlow, setIsSlow] = useState(false);

	useEffect(() => {
		setIsSlow(false);
		if (!loading || !slowMessage) return;
		const timeout = setTimeout(() => setIsSlow(true), slowAfterMs);
		return () => clearTimeout(timeout);
	}, [loading, slowMessage, slowAfterMs]);

	return (
		<Backdrop className={classes.backdrop} open={loading || false}>
			<CircularProgress />
			{isSlow && slowMessage && (
				<Typography className={classes.message}>{slowMessage}</Typography>
			)}
		</Backdrop>
	);
};

export default SpinnerLoading;
